<template>
  <div
    class="error-page
      tw-pl-20
      tw-absolute
      tw-inset-0
      tw-bg-fixed
      tw-bg-no-repeat
      tw-bg-cover"
  >
    <div
      class="
      content
      tw-flex
      tw-justify-between
      tw-h-screen
      tw-items-center
      sm:tw-flex-col
      md:tw-flex-row"
    >
      <div class="md:tw-w-7/12 sm:tw-w-12/12 sm:tw-mt-5">
        <h1 v-if="error.statusCode === 404" class="tw-font-bold tw-text-3xl tw-w-3/4">
          {{ $t(
            'layout-error.404-title',
            'Oops ! The page you were looking for has not been shot yet.'
          )
          }}
        </h1>
        <h2 v-else-if="assignmentError">
          {{ $t(
            'layout-error.403-assignment',
            'Sorry, this assignment is already attributed to another photographer.'
          ) }}
        </h2>
        <h1 v-else>
          {{ $t(
            'layout-error.error',
            'An error occured'
          )
          }}
        </h1>

        <p v-if="error.statusCode === 404" class="tw-text-base tw-w-3/4 tw-mt-4">
          {{ $t(
            'layout-error.404-description',
            'The page may has also moved to another place or it is currently unaivailable.'
          ) }}
        </p>
        <div class="tw-mt-16">
          <o-button class="cta tw-bg-orange tw-capitalize" round @click="$router.push('/')">
            {{ $t(
              'layout-error.404-cta-home',
              'Go to homepage'
            ) }}
          </o-button>
          <o-button round outline class="cta tw-ml-8 tw-capitalize" @click="$router.back()">
            {{ $t(
              'layout-error.404-cta-back',
              'Go back'
            ) }}
          </o-button>
        </div>
      </div>
      <div
        class="
        sm:tw-w-12/12
        md:tw-w-5/12
        tw-flex
        sm:tw-justify-end
        md:tw-justify-center
        tw-flex-shrink-0
        sm:tw-flex-row
        md:tw-flex-col
        "
      >
        <camera
          class="
          tw-self-center
          md:tw-w-7/12
          sm:tw-w-2/12"
        />
        <logo-404
          v-if="error.statusCode === 404"
          class="
          md:tw-w-5/12
          sm:tw-w-2/12
          sm:tw-ml-6"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import camera from '~/assets/img/camera.svg';
  import logo404 from '~/assets/img/404.svg';

  export default {
    components: {
      camera,
      logo404,
    },
    layout: 'ocus/default',
    props: {
      error: {
        type: Object,
        default: () => ({}),
      },
    },
    data: () => ({
      assignmentError: false,
    }),
    mounted() {
      if (this.$route.name === 'missions-id' && this.error.statusCode === 403) {
        this.assignmentError = true;
      }
    },
  };
</script>

<style lang="scss" scoped>
  .error-page {
    background-image: url('/curve.svg');
    .btn.cta {
      &:hover {
        background-color: $darkOrange !important;
      }
      &.btn-outline-default {
        border:$orange 1px solid !important;
        color: $orange;
      }
    }

    @media (max-width: 640px) {
      .content {
        @apply tw-flex-col tw-mt-8;
      }
    }
  }
</style>
